import React from 'react';
import { LabelField } from '../Controls';
import './manager-discount.css';

const LocationManagerDiscountRow = ({ label, value, discountTotal, isQuoteDiscountTypeManager }) => {
  const discountTotalValue = isQuoteDiscountTypeManager ? discountTotal : '-';

  return (
    <div className="row-location-manager-discount">
      <LabelField parentClassName="discount-percent-wrapper" label={label} value={value + '%'} />
      <LabelField parentClassName="discount-total-wrapper" className="discount-total" value={discountTotalValue} />
    </div>
  );
};

export default LocationManagerDiscountRow;
